<template>
    <el-row>
        <el-row v-bind:gutter="15" class="groupCraftDateRow">
            <el-tag type="info" size="small">创建日期:{{ groupCraftRecord.created }}</el-tag>
            <el-tag size="small">计划开始 : {{ groupCraftRecord.plan_start }}</el-tag>
            <el-tag size="small">计划结束 : {{ groupCraftRecord.plan_end }}</el-tag>
        </el-row>
        <el-row v-bind:gutter="15" class="groupCraftDateRow">
            <el-tag type="success" size="small">实际开始 [审核通过] : {{ groupCraftRecord.actual_start }}</el-tag>
            <el-tag type="success" size="small">实际结束 [完成上报] : {{ groupCraftRecord.actual_end }}</el-tag>
        </el-row>

        <el-divider></el-divider>
        <group-craft-table ref="groupCraftTable" :group-craft-record="groupCraftRecord"/>

        <!-- 备注信息 -->
        <el-row style="margin-top: 8px">
            <el-input v-if="isMdfStatue"
                      size="mini"
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 4}"
                      placeholder="备注信息"
                      v-model="groupCraftRecord.remark">
            </el-input>
            <span style="float: left" v-else>{{ groupCraftRecord.remark }}</span>
        </el-row>

        <el-row style="margin-top: 8px">
            <!-- 更新小组任务 -->
            <el-button
                    type="primary"
                    style="float: left"
                    :loading="updateLoading"
                    size="mini"
                    icon="el-icon-refresh-right"
                    :disabled="!((isMdfStatue || isVerify ) && !groupCraftRecord.finish)"
                    @click="updateGroupRecord">更新
            </el-button>

            <!-- 新建上报批次 -->
            <el-button
                    style="float: left"
                    type="primary"
                    :disabled="!(isVerify && !groupCraftRecord.finish)"
                    icon="el-icon-circle-plus"
                    @click="createNewGroupBatchClick"
                    size="mini">新建上报批次
            </el-button>

            <!-- 删除小组任务 -->
            <el-button
                    style="float: left"
                    type="danger"
                    :loading="deleteLoading"
                    size="mini"
                    :disabled="!isMdfStatue"
                    icon="el-icon-delete-solid"
                    @click="deleteGroupRecord">
                删除
            </el-button>

            <!-- 完成上报 -->
            <el-button
                    style="float: left"
                    type="primary"
                    :loading="finishLoading"
                    size="mini"
                    :disabled="!(isVerify && !groupCraftRecord.finish)"
                    icon="el-icon-finished"
                    @click="finishGroupRecord">
                完成上报
            </el-button>
        </el-row>

        <!-- 创建小组上报批次数据 -->
        <create-new-group-batch  ref="newGroupBatch"/>

        <!-- 展现小组上报批次数据 -->
        <group-batch-detail></group-batch-detail>

    </el-row>
</template>

<script>
    import CreateNewGroupBatch from "./CreateNewGroupBatch"
    import GroupBatchDetail from "./groupCraftcps/GroupBatchDetail"
    import GroupCraftTable from "./GroupCraftTable"
    import {mapMutations, mapGetters, mapState} from 'vuex'

    export default {
        name: "GroupCraft",
        props: {
            groupCraftRecord: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                finishLoading: false,
                updateLoading: false,
                deleteLoading: false,
            }
        },
        computed: {
            isStrict() {
                if (this.currentCraft) {
                    return this.isStrictCraftRecord(this.currentCraft)
                }
            },

            ...mapGetters({
                isMdfStatue: 'currentCraftIsMdf',
                isVerify: 'currentCraftIsVerify',
                isStrictCraftRecord: 'isStrictCraftRecord',
            }),
            ...mapState(['currentCraft'])
        },
        methods: {

            /**
             * 在操作小组任务单['更新/删除']之前，对数据进行处理
             * 将临时数据如 _price， _plan_num 同步到真正的数据字段
             */
            beforeRequest() {
                const fields = ['price', 'plan_num', 'scrap_num']

                this.groupCraftRecord.sizegroupcraftrecord_set.forEach(sizeGroupCraftRecord => {
                    fields.forEach(field => {
                        const tempField = '_' + field
                        sizeGroupCraftRecord[field] = sizeGroupCraftRecord[tempField]
                    })
                })
            },

            afterResponse() {
                this.$refs.groupCraftTable.initChangeFields()
            },

            /**
             * 更新完成小组任务单
             */
            updateGroupRecord() {
                if (!this.checkGroupRecordPlanNum()) {
                    return
                }
                this.beforeRequest()
                this.updateLoading = true
                const url = `${this.$const.craftGroupRecordUrl}/${this.groupCraftRecord.id}/`

                const data = {
                    sizegroupcraftrecord_set: this.groupCraftRecord.sizegroupcraftrecord_set,
                }
                if (this.groupCraftRecord.remark) {
                    data['remark'] = this.groupCraftRecord.remark
                }
                this.$patchRequest(url, data).then((response) => {
                    this.updateLoading = false
                    this.handleResponse(response)
                    this.$message.success('保存成功')
                })
            },

            /*
             * 删除完成小组任务
             */
            deleteGroupRecord() {
                this.deleteLoading = true
                this.beforeRequest()
                const url = `${this.$const.craftGroupRecordUrl}/${this.groupCraftRecord.id}/`
                this.$deleteRequest(url).then((response) => {
                    this.$message.success('删除成功，请刷新')
                    this.handleResponse(response)
                    this.deleteLoading = false

                }).catch(error => {
                    this.deleteLoading = false
                })
            },

            /*
             * 完成小组任务上报
             */
            finishGroupRecord() {
                if (!this.checkGroupRecordPlanNum()) {
                    return
                }

                if (!this.checkFinishNUm()) {
                    return;
                }
                this.finishLoading = true
                const finishUrl = `${this.$const.craftGroupRecordUrl}${this.groupCraftRecord.id}/finish/`
                this.$postRequest(finishUrl)
                    .then(response => {
                        this.handleResponse(response)
                        this.finishLoading = false
                        this.$message({
                            type: 'success',
                            showClose: true,
                            message: '成功完成小组任务'
                        })
                    })
                    .catch(error => {
                        this.finishLoading = false
                    })

            },

            /*
             * 检查上报的数据
             */
            checkFinishNUm() {
                // 如果不是严格工艺检测
                // 则直接返回 true
                if (!this.isStrict) {
                    return true
                }

                if (this.groupCraftRecord.finish_num + this.groupCraftRecord.scrap_num
                    !== this.groupCraftRecord.plan_num) {

                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: '报次数量 + 上报数据 不等于 分配数量'
                    })
                    return false
                }

                return true
            },
            checkGroupRecordPlanNum() {
                // 如果不是严格工艺检测
                // 则直接返回 true
                if (!this.isStrict) {
                    return true
                }

                for (let i = 0; i < this.groupCraftRecord.sizegroupcraftrecord_set.length; i++) {
                    const sizeGroupRecord = this.groupCraftRecord.sizegroupcraftrecord_set[i]
                    if (sizeGroupRecord.finish_num > sizeGroupRecord.plan_num) {
                        this.$message.error(`错误:${sizeGroupRecord.shop_id}的上报数量 大于 通知数量`)
                        return false
                    }
                    if (sizeGroupRecord.plan_num > sizeGroupRecord.sumPlan) {
                        this.$message.error(`错误:${sizeGroupRecord.shop_id}分配数量不能大于${sizeGroupRecord.sumPlan}`)
                        return false
                    }
                }
                return true
            },
            handleResponse(response) {
                // 从响应中获取 craft
                const craft_record = response.data['craft_record']

                // 更新 currentCraft
                this.updateCurrentCraft(craft_record) // 更新 currentCraft
                this.afterResponse()
            },
            createNewGroupBatchClick() {
                this.setCurrentGroupCraft(this.groupCraftRecord)
                if (this.$refs.newGroupBatch) {
                    this.$refs.newGroupBatch.init()
                }
                this.setCreateGroupBatchShow(true)
            },
            ...mapMutations([
                'updateCurrentCraft',
                'setCurrentGroupCraft',
                'setGroupBatchDetailShow',
                'setGroupBatchDetailTitle',
                'setCreateGroupBatchShow',
            ])
        },

        components: {GroupCraftTable, GroupBatchDetail, CreateNewGroupBatch},
    }
</script>

<style scoped>
    .groupCraftDateRow span {
        float: left;
        margin: 3px 15px;
    }
</style>